export default "__VITE_ASSET__rRGOFGYd__"